import { FaqAccordion } from "../components/FaqAccordion";
import { Reveal } from "../components/Reveal";

export default function FaqPage() {
  return (
    <div className="pt-32 pb-32 min-h-[70vh]">
      <div className="max-w-3xl mx-auto px-6">
        <Reveal>
          <p className="overline mb-4 text-center">Questions fréquentes</p>
          <h1 className="font-display text-5xl md:text-6xl mb-16 text-center" style={{ fontWeight: 300 }}>Tout savoir sur le sérum</h1>
        </Reveal>
        <FaqAccordion />
      </div>
    </div>
  );
}
